import { useQuery } from '@tanstack/react-query'

import { api } from '@/utils/api'

const fetchSharedWith = async (linkId: string) => {
  const resp = await api.get(`/links/${linkId}/shared-with`)
  return resp.data.data ?? []
}

export const useSharedWith = (linkId?: string) => {
  return useQuery<{ id: string; name: string; email: string; image: string }[]>(
    {
      enabled: !!linkId,
      queryKey: ['shared-with', linkId],
      queryFn: () => fetchSharedWith(linkId!),
    }
  )
}
